<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      show-save-button
      unit="标注"
      id-key="MarkId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标注" prop="MarkName">
              <el-input size="mini" v-model="data.MarkName" placeholder="请填写标注"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="Sn">
              <el-input-number :min="0" v-model="data.Sn"></el-input-number>
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        MarkId: 0,
        MarkName: "",
        Sn: 0,
      },
      StartYear: "",
      api: require("@/api/analyse/mark").default,
      isMB: this.$store.state.isMB,
      rules: {
        MarkName: [{ required: true, message: "请填写标注" }],
        Sn: [{ required: true, message: "请填写序号" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
    },
    onEditOpened(row) {

    },
  },
};
</script>
<style lang="scss">
</style>